import {
    getAutocompleteAddressRequest,
    getAutocompleteCategorySubCategoryRequest,
    getAutocompleteCommuneAddressRequest,
    getAutocompleteCompanyRequest,
    getAutocompleteUserRequest,
} from "lib/api/autocomplete";

export const fetchAutocompleteUser = (params?: HashMap<unknown>) => getAutocompleteUserRequest(params);

export const fetchAutocompleteCompany = (params?: HashMap<unknown>) => getAutocompleteCompanyRequest(params);

export const fetchAutocompleteCategorySubCategory = (params?: HashMap<unknown>) =>
    getAutocompleteCategorySubCategoryRequest(params);

export const fetchAutocompleteAddress = (params?: HashMap<unknown>, type: string = "housenumber") =>
    getAutocompleteAddressRequest(params, type);

export const fetchAutocompleteCommuneAddress = (params?: HashMap<unknown>) =>
    getAutocompleteCommuneAddressRequest(params);
